export default "__VITE_ASSET__BV_S3SHu__"